import { render, staticRenderFns } from "./reportIssue.vue?vue&type=template&id=44e20dcb&"
import script from "./reportIssue.vue?vue&type=script&lang=ts&"
export * from "./reportIssue.vue?vue&type=script&lang=ts&"
import style0 from "./reportIssue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports